<template>
  <article v-if="document" class="rb-legal-document" dir="rtl" lang="fa" :data-legal-version="document.version">
    <h2>{{ document.title }}</h2>
    <p class="rb-legal-version">نسخهٔ متن <bdi dir="ltr">{{ document.version }}</bdi> · تاریخ متن <bdi dir="ltr">{{ document.textDate }}</bdi></p>
    <p v-for="(paragraph, index) in document.paragraphs" :key="index">
      <strong v-if="paragraph.lead">{{ paragraph.lead }} </strong>{{ paragraph.text }}
    </p>
  </article>
</template>

<script>
import {getLegalDocument} from '@/legal/documents'

export default {
  name: 'LegalDocument',
  props: {documentId: {type: String, required: true}},
  computed: {document() {return getLegalDocument(this.documentId)}},
}
</script>

<style scoped>
.rb-legal-document{color:#173e50;font-size:1rem;line-height:2;overflow-wrap:anywhere;text-align:right}
.rb-legal-document h2{font-size:1.4rem;line-height:1.8;margin:0 0 12px}
.rb-legal-document p{margin:0 0 16px}
.rb-legal-version{font-size:.85rem;color:#526974}
</style>
